import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import { CumulativeReportFilterValues } from 'pages/Finance/CumulativeReport/CumulativeReportFilter';
import qs from 'qs';
import { CumulativeReport, CumulativeReportSummary } from 'types/embedded/cumulativeReport';

export type CumulativeReportResponse = {
  reportItems: CumulativeReport[];
  accountsSummaryItems: CumulativeReportSummary[];
};
export const getCumulativeReport = async (
  filter: CumulativeReportFilterValues = {} as CumulativeReportFilterValues,
): Promise<CumulativeReportResponse> => {
  const params = qs.stringify(
    {
      ...filter,
    },
    { arrayFormat: 'indices', encode: true },
  );
  return axios
    .get(`v2/${Resources.CumulativeReport}?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
